import { MainContentAssessment } from "../MainContentArea/MainContent";
import "./Assessment-dashboard.css";
import { useNavigate } from "react-router-dom";

export const AssessmentDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="assessment-dashboard">
      <div className="maincontentarea-assessment">
        <MainContentAssessment />
      </div>

      <div className="termsOfServiceDemo">
        <div className="terms-and-privacy-body-text">
          <p>
            By continuing, you agree to Mindsherpa’s&nbsp;
            <span
              className="terms-and-privacy-link-text"
              onClick={() => navigate("/terms-of-usage")}
              style={{ cursor: "pointer" }}
            >
              Terms of Service
            </span>
            &nbsp;and&nbsp;
            <span
              className="terms-and-privacy-link-text"
              onClick={() => navigate("/privacy-policy")}
              style={{ cursor: "pointer" }}
            >
              Privacy Policy
            </span>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
